<template>
  <display-stat
    :year="year"
    :month="month"
    :from="from"
    :to="to"
    :dataByMonth="dataByMonth"
    :dataEvolution="removedUsersEvolution"
  >
    <template #title>
      {{ label }}
    </template>

    <template #period>
      {{ currentYear }}
    </template>

    <template #amount>
      {{ displayAmount(data) }}
    </template>
  </display-stat>
</template>

<script>
import { ref, computed } from 'vue'
import useStatistics from '@composables/statistics/use-statistics.js'
import useStates from '@composables/statistics/use-states.js'
import useNumbers from '@composables/use-numbers'
import DisplayStat from '@components/statistics/display-stat'

export default {
  props: {
    year: {
      type: [Number, null],
      default: null,
    },

    month: {
      type: [Number, null],
      default: null,
    },

    from: {
      type: [Date, null],
      default: null,
    },

    to: {
      type: [Date, null],
      default: null,
    },

    label: {
      type: [String, null],
      default: null,
    },
  },

  setup (props) {
    const { displayAmount, isNumber } = useNumbers()
    const { removed } = useStates()
    const { 
      removedUsers, 
      removedUsersByMonth, 
      removedUsersEvolution,
      year: currentYear,
    } = useStatistics(props)

    const data = computed(() =>
      (props.year || props.month || (props.from && props.to)) 
      ? removedUsers.value
      : removed.value
    )

    const dataByMonth = computed(() =>
      (props.year || props.month || (props.from && props.to)) 
      ? removedUsersByMonth.value
      : []
    )

    return {
      data,
      dataByMonth,
      removedUsersEvolution,
      currentYear,
      displayAmount,
    }
  },

  components: {
    DisplayStat
  }
}
</script>
